var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogLoginStreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 320,
    height: 261,
    viewBox: "0 0 320 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape \xC2\xB7 cut corner",
    d: "M303.793 0.5L319.5 16.207V260.5H0.5V0.5H303.793Z",
    fill: "#15170F",
    stroke: "#262B1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogLoginStreak);
export default __webpack_public_path__ + "static/media/dialog-login-streak.a334ed09e520a0de8ed2e13d35869da7.svg";
export { ForwardRef as ReactComponent };